/* eslint-disable jsx-a11y/anchor-has-content */
// TODO: Need to follow up to see if we have some marketing constraints around this,
// given the original code allowed the referer through
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import { Heading, Text } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { getContentfulImage } from '../../../../lib/99dodContentfulClient';
import Video from '../Video';
import TileFooter from './Footer';
import TileHeader from './Header';
import { COLOR } from './constants';
import { TileProps } from './interfaces';

const Container = (props: TileProps) => {
    return (
        <StyledContainer>
            {props.image?.url && (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                    className={'tile__image'}
                    src={getContentfulImage(props.image.url, 800)}
                    title={props.image.title}
                    alt={props.image.description}
                />
            )}
            {props.video?.url && (
                <Video className={'tile__video'} src={props.video.url} autoPlay loop muted />
            )}

            <TileHeader {...props} />

            {props.text && props.author && (
                <Heading
                    className={clsx('tile__text', { 'tile__text--quote': props.author })}
                    appearanceLevel={4}
                    accessibilityLevel={7}
                >
                    <span className={'tile__quote'}>“</span>
                    {props.text}
                </Heading>
            )}

            <a href={props.link} target="_blank" className={'tile__link-panel'} />

            {props.text && !props.author && (
                <Text
                    className={clsx('tile__text', {
                        'tile__text--hover': props.link && (props.image || props.video),
                    })}
                    size="size3"
                >
                    {props.text}
                </Text>
            )}

            {(props.logo ||
                props.designedBy ||
                props.category ||
                props.link ||
                props.author ||
                props.business) && <TileFooter {...props} />}
        </StyledContainer>
    );
};

export default Container;

export const StyledContainer = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-flow: column;
    text-decoration: none;
    color: ${COLOR.WHITE};

    .tile__image,
    .tile__video {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .tile__video {
        opacity: 0 !important;
        transition: opacity 300ms cubic-bezier(0.19, 1, 0.22, 1);
    }

    .tile__quote {
        width: 80px;
        height: 80px;
        font-family: 'Graphik Medium', Arial, sans-serif;
        font-size: 2.125rem;
        position: absolute;
        left: 10px;
        top: 10px;
    }

    .tile__text {
        position: relative;
        padding: 15px 20px 15px 15px;
        font-weight: bold;

        &--quote {
            padding-bottom: 0;
            padding-left: 40px;
            font-size: 2.125rem;
            line-height: 1.1764;

            ${mediaQuery.minimum('normal')} {
                margin-top: 15px;
            }
        }

        &--hover {
            color: ${COLOR.WHITE};
            position: relative;
            z-index: 1;
            opacity: 0;
            transition: opacity 300ms cubic-bezier(0.19, 1, 0.22, 1);
        }
    }

    .tile__link-panel {
        width: 100%;
        height: 100%;
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;

        /* 
        Styled-Components has no support for @at-root.
        https://github.com/styled-components/styled-components/issues/1831#issuecomment-401384558

        In SCSS:

        @at-root {
        :global(.no-touchevents) & {
            display: block;
        }

        TODO: Check if there is a better way to handle this in styled-components
        */
        :global(.no-touchevents) & {
            display: block;
        }
    }

    &:hover {
        text-decoration: none;
    }

    &::before {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        display: block;
        background: rgba(35, 35, 35, 0.85);
        opacity: 0;
        transition: opacity 300ms cubic-bezier(0.19, 1, 0.22, 1);
        z-index: 1;
    }
`;
